import { FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import React from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

const PreviousCertificateFormSection = ({ requiredPrevCertNumber = false, infoText }) => {
  const { t } = useTranslation();
  return (
    <FormSection label={"t.prev.certificate"}>
      <GridContainer>
        <GridItem sm={12} md={12}>
          <Alert severity={"info"}>{t(infoText)}</Alert>
        </GridItem>
      </GridContainer>
      <GridContainer spacing={3}>
        <GridItem sm={6} md={6}>
          <InputFormField
            required={requiredPrevCertNumber}
            fieldName={"prevCertNumber"}
            labelCode={"l.prevCertNumber"}
          />
        </GridItem>
        <GridItem sm={12} md={12}>
          <InputFormField required={false} fieldName={"note"} labelCode={"l.note"} />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};

export default PreviousCertificateFormSection;
